import { render, staticRenderFns } from "./TablePoc.vue?vue&type=template&id=c07a46e8&"
import script from "./TablePoc.vue?vue&type=script&lang=ts&"
export * from "./TablePoc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports